import { render, staticRenderFns } from "./BaseLabelWithFreightServices.vue?vue&type=template&id=65f21cfa&scoped=true&"
import script from "./BaseLabelWithFreightServices.vue?vue&type=script&lang=js&"
export * from "./BaseLabelWithFreightServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f21cfa",
  null
  
)

export default component.exports